/*
 * @Author: cc
 * @Date: 2020-04-02 10:00:07
 * @LastEditTime: 2021-11-10 11:12:21
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\myManuscript\newspaperAwaitRevise\newspaperAwaitReviseRouter.js
 * @Description: 
 */
'use strict';
angular.module('newspaperAwaitReviseRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.iWo.newspaperAwaitRevise', {
            url: '/newspaperAwaitRevise?newrevise', // 判断是否是新媒体待修订true为新媒体，没传为以前的
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/myManuscript/newspaperAwaitRevise/newspaperAwaitRevise_tpl.html',
                    controller: 'newspaperAwaitReviseCtrl'
                }
            }
        });
    }]);
